export interface ChooseLocation {
  extendedProperties: any;
  id: string;
  name: string;
  description: string;
  latitude: number;
  longitude: number;
  address1: string;
  address2: string;
  address3: string;
  address4: string;
  postcode: string;
  phoneNumber1: string;
  phoneNumber2: string;
  notes1: string;
  notes2: string;
  clickCollectPaymentPurses: number[];
  orderNowOnly: boolean;
  hideInPreorderSiteList: boolean;
  imageURL: string;
  deliverOrders: boolean;
  guestCheckout: boolean;
}

export interface Timeslot {
  // start: Date;
  // end: Date;
  start: string;
  end: string;
  periodID?: number;
  isOrderNow: boolean;
}

export interface LocationTimeslot {
  periodID: number;
  periodName: string;
  // startTime: Date;
  // endTime: Date;
  startTime: string;
  endTime: string;
  timeslots: Timeslot[];
}

export interface ProductGroup {
  id: number;
  name: string;
}

export interface Price {
  id: number;
  name: string;
  portionSize: number;
  price: number;
  oPrice?: number;
}

export interface Nutrition {
  calories: string;
  carbohydrate: string;
  fat: string;
  fibre: string;
  protein: string;
  saturates: string;
  sodium: string;
  sugars: string;
  servesFrom: number;
  servesTo: number;
}

export interface CondimentsItems {
  itemType: string;
  id: number;
  name: string;
  productID: number;
  productGroup: ProductGroup;
  prices: Price[];
  nutrition: Nutrition;
  isChecked?: boolean;
}

export interface Condiments {
  itemType: string;
  id: number;
  name: string;
  minQty: number;
  maxQty: number;
  maxPerItem: number;
  checkedCount?: number;
  childItems: CondimentsItems[];
  isRequired?: boolean;
}

export interface MenuProduct {
  itemType: string;
  id: number;
  name: string;
  description: string;
  imageURL?: string;
  productID: number;
  productGroup: ProductGroup;
  minQty: number;
  maxQty: number;
  maxPerItem: number;
  prices: Price[];
  allergens: string[];
  dietaryTypes: string[];
  nutrition: Nutrition;
  isValid?: boolean;
  childItems: Condiments[];
  stopped: boolean;
  restrictedAge: number;
}

export interface Item {
  stopped: boolean;
  itemType: string;
  id: number;
  name: string;
  description: string;
  imageURL: string;
  productID: number;
  productGroup: ProductGroup;
  minQty: number;
  maxQty: number;
  maxPerItem: number;
  prices: Price[];
  allergens: string[];
  dietaryTypes: string[];
  nutrition: Nutrition;
  childItems: MenuProduct[];
  restrictedAge: number;
}

export interface LocationMenus {
  id: number;
  name: string;
  description?: string;
  items: Item[];
}

export enum LocationMenuItemTypes {
  Course = 'Course',
  Product = 'Product',
  Instruction = 'Instruction',
}

export enum LocationPropTypes {
  PaymentMerchant = 0,
  DisplayMenu = 1,
  MeetingRoom = 2,
  MinimumOrderSpend = 3,
  DeliveryOnly = 4,
}

export enum TimeslotSelection {
  Enabled = '2',
  Disabled = '1',
}
